export const padTimeUnit = (value: number) => value.toString().padStart(2, '0');

export const formatCountdownLabel = (diffMs: number) => {
  const totalSeconds = Math.max(Math.floor(diffMs / 1000), 0);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) {
    return `${days}d ${padTimeUnit(hours)}:${padTimeUnit(minutes)}`;
  }

  return `${padTimeUnit(hours)}:${padTimeUnit(minutes)}:${padTimeUnit(
    seconds,
  )}`;
};
